/* global $ */
import { _ } from "$json/lib/gettext.js";
import { compose, when, prop, hasPath, find } from "$json/lib/functional.js";
import "$control-filter";

const MAXLENGTH = 50;
$(document).bind(
  "bb-p:control-filter",
  function (ev, control, group, index, grid, data) {
    const lang = _("lang");
    if (control.id && !hasPath(["metadata", "quotable"])(control)) {
      let label = compose(
        when(
          Boolean,
          compose(s => s.trim(), prop("value"))
        ),
        find(c => c.isfor === control.id)
      )(group.controls);
      if (label) {
        if (label.length > MAXLENGTH) {
          // Too long to be of use
          console &&
            console.warn &&
            console.warn(
              "Label too long for error message, use metadata quotable",
              label
            );
          return;
        }
        if (
          lang === "nl" &&
          /^[wW](elke|at|aar|aarom|anneer|aarmee)\b/.test(label)
        ) {
          // Too long to be of use
          console &&
            console.warn &&
            console.warn(
              "Label starts with a question word, better use metadata quotable",
              label
            );
        }
        // Make first letter lowercase if it does not seem like the
        // start of an abbreviation -- unless German, Luxembourgish or Bavarian
        if (!["de", "lb", "bar"].includes(lang)) {
          if (/^[A-Z][a-z]/.test(label)) {
            label = compose(s => s.slice(0, 1).toLowerCase() + s.slice(1))(
              label
            );
          }
        }
        if (label.endsWith(":")) {
          label = label.slice(0, label.length - 1);
        }
        if (!control.metadata) control.metadata = {};
        control.metadata.quotable = label;
      }
    } else if (control.colname && !hasPath(["metadata", "quotable"])(control)) {
      if (!control.metadata) control.metadata = {};
      control.metadata.quotable = control.colname;
    }
  }
);
